import React from 'react';
import { useState, useRef, useEffect} from 'react';
import './reservationTriplePicker.css';


import Datepicker from '../common/Datepicker/Datepicker.jsx';

function ReservationTriplePickerRealtime({

}) {
    if (typeof reservationData == 'undefined') {
        return null;
    }

    if (! Array.isArray(reservationData.guestsOptions) || reservationData.guestsOptions.length == 0) {
        return null;
    }

    const [showDatepicker, setShowDatepicker]   = useState(false);
    const [numGuest, setNumGuest] = useState(reservationData.guestsOptions[0]);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [availabilityCheckResponse, setAvailabilityCheckResponse] = useState(reservationData.checkoutError);   // null for check to do.  check happen when data/guests are picked
    const [showAvailabilityError, setShowAvailabilityError] = useState(reservationData.checkoutError ? true : false); 
    const [slotPage, setSlotPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    //const [showConfirmError, setShowConfirmError] = useState(false); 

    
    let slotsPerPage = 9;
    let rd = reservationData;
    let productId = reservationData.productId;

    function _selectedTimeChangedUIUpdate(t) {
        let btn =  document.getElementById('buynow-button');
        if (btn) {
            if (t) {
                btn.classList.remove('disabled')
            } else {
                btn.classList.add('disabled')
            }
        }
    }

    function numGuestChanged(e) {
        if (! reservationData.isAjax) {
            return;
        }

        let n = e.target.value
        setNumGuest(n);

        if (selectedDate) {
            setSelectedTime('');
            //setAvailabilityCheckResponse(null);
            //setSlotPage(0);
            getSevenRoomsVenueAvailability(productId, selectedDate, n);
        }
    }

    function clandarBtnClicked(e) {
        if (! reservationData.isAjax) {
            return;
        }
        
        setShowDatepicker(true);

        setTimeout(function(){
            let datecell = document.querySelector('.rtp_date_cell.active');
            if (datecell) {
                datecell.focus();
            }
        }, 0);
    }

    function onDatePicked(date) {
        if (! reservationData.isAjax) {
            return;
        }

        setSelectedDate(date);
        setSelectedTime('');
        setShowDatepicker(false);
        //setAvailabilityCheckResponse(null);
        //setSlotPage(0);

        getSevenRoomsVenueAvailability(productId, date, numGuest);
    }

    function timeClicked(e) {
        if (! reservationData.isAjax) {
            return;
        }
        let t = e.target.dataset.timeslot
        setSelectedTime(t);
    }

    function _getTimeSlotCss(slot, selectedTime, index){
        let selected =  (slot.real_datetime_of_slot == selectedTime);
        let css = {
            borderColor: reservationData.siteColors.primaryButtonBackground || reservationData.siteColors.primary
        };
        if (selected) {
            css.background = reservationData.siteColors.primaryButtonBackground || reservationData.siteColors.primary
            css.color = reservationData.siteColors.primaryButtonFontColor || reservationData.siteColors.white;
            
        }

        let page = Math.floor(index / slotsPerPage);
        if (page == slotPage) {
            css.display = 'block';
        } else {
            css.display = 'none';
        }

        return css;
    }

    function onOverlayPicked(e) {
        if (e.target.classList.contains('datepicker_ra_overlay')) {
            setShowDatepicker(false);
        }
    }

    // senario: 'check' or 'confirm'.  confirm not used now.
    // check happens when date/guests are picked
    // confirm happens when user 'start reservation'
    function getSevenRoomsVenueAvailability(productId, date, partySize, senario) {
        if (typeof senario == 'undefined') { senario = 'check'}
        const formData = new FormData();
        formData.append('productId', productId);
        formData.append('date', date);
        formData.append('partySize', partySize);
        formData.append('stk', g_ifonlycsrftoken);
        let url =  (g_is_mobile ? '/m' : '') + '/product/GetSevenRoomsVenueAvailability';
        setIsLoading(true);
        setTimeout(function() {
            document.querySelector('.loading_msg').innerText= reservationData.strings.loadingMsg
        }, 10);
        fetch(url, {
            method: 'POST',
            body: formData 
        }).then(Result => Result.json())
        .then(data => {
            if (typeof(localStorage) != 'undefined' && localStorage.fakeNoAavai == '1' ) {
                data.timeslots = [];
            }
            if (typeof(localStorage) != 'undefined' && localStorage.fakeAavaiResult ) {                     // '0' to fake error. '' to reset.
                data.result = localStorage.fakeAavaiResult * 1;
                data.request_id = 'sdkfjslkdjflsdjfljdlfjsdljfsdljfklsjfklsdjfksdjfkdjflksdjfklsdjfkjsdkfjsdkjfkdsjflksjdfkjskfjsfdjlsdjflsjflk';
            }
            if (typeof(localStorage) != 'undefined' && localStorage.fakeTimeSlots == '1') {
                let slots = [];
                for (let i=10; i<40; i++) {
                    let slot = {
                        real_datetime_of_slot: '2025-09-19 12:' + i +  ':00', 
                        time_display: "12:" + i + " pm"
                    }
                    slots.push(slot);
                }
                data.timeslots = slots;
            }

            if (senario == 'check') {   
                setAvailabilityCheckResponse(data);
                setSlotPage(0);
                if (data.result == 0) {
                    setShowAvailabilityError(true);
                    setTimeout(function() {
                        //document.querySelector('.rtp_availability_err_overlay .try_again_btn').focus();
                        document.querySelector('.rtp_availability_err_overlay .rtp_avail_error_msg').focus();
                    }, 10);
                } else {
                    if (data.timeslots.length == 0) {
                        setTimeout(function() {
                            let msg_dom = document.querySelector('.rtp_no_avail_msg');
                            //msg_dom.setAttribute('aria-live', 'assertive');
                            msg_dom.focus();
                        }, 10);
                    } else {
                        setTimeout(function() {
                            let msg_dom = document.querySelector('.rtp_timeslots_div .timeslot_btn');
                            //msg_dom.setAttribute('aria-live', 'assertive');
                            msg_dom.focus();
                        }, 10);
                    }
                }
            }
            /*
            else if (senario == 'confirm') {
                let confirmed = false;
                if (data.result == 1 && Array.isArray(data.timeslots)) {
                    for (let i in data.timeslots) {
                        let slot = data.timeslots[i];
                        if (slot.real_datetime_of_slot == selectedTime) {
                            confirmed = true;
                            break;
                        }
                    }
                }
                console.log('confirm');
                if (! confirmed) {
                    setShowConfirmError(true);
                }
            }
            */
        })
        .catch(error => {
            alertEx('Eorror in checking venue.');
            setAvailabilityCheckResponse(null);
            setSlotPage(0);
        })
        .finally(() => {
            setIsLoading(false);
            setTimeout(function() {
                document.querySelector('.loading_msg').innerText=''
            }, 10);
        });
    }

    function getDateDisplay(date) {
        if (typeof(g_locale) != 'undefined' && date != '') {
            return g_locale.formatDate(date);
        }
        return date;
    }

    function getTimeDisplay(time, time_display) {
        if (time == undefined || time == '') {
            return time_display;
        }
        if (typeof(g_locale) != 'undefined' && time != '') {
            return g_locale.formatTime(time);
        }
        return time_display;
    }

    function refIdClicked() {
        let refId_dom = document.querySelector('.rtp_ref_id_span');
        if (refId_dom.classList.contains('expanded')) {
            refId_dom.classList.remove('expanded');
        }
        else {
            refId_dom.classList.add('expanded');
        }
    }

    function getAvailabilityErrorMsg(availabilityCheckResponse) {
        if (availabilityCheckResponse.origin == 'sessionVar') {
            let msg = availabilityCheckResponse.message;
            if (availabilityCheckResponse.httpCode == '400' && msg.includes('phone number is required to book')) {
                return rd.strings.checkoutError400;
            }
            else {
                return rd.strings.checkoutError;
            }
        }
        return rd.strings.availabilityError;
    }

    function onCloseAvailabilityError() {
        setSelectedDate('');
        setSelectedTime('');
        setAvailabilityCheckResponse(null);
        setSlotPage(0);

        setShowAvailabilityError(false);
    }

    function onReturnHome(e) {
        e.preventDefault();
        e.stopPropagation();

        if (rd.accessCodeRedirectUrl) {
            window.location.href = rd.accessCodeRedirectUrl;
        } else {
            window.location.href = '/';
        }
    }

    function onPreSlotPageClick(e) {
        if (availabilityCheckResponse && availabilityCheckResponse.result == 1 && Array.isArray(availabilityCheckResponse.timeslots)) {
            if (slotPage > 0) {
                setSlotPage(slotPage - 1);
            }
        }
    }

    function onNextSlotPageClick(e) {
        if (availabilityCheckResponse && availabilityCheckResponse.result == 1 && Array.isArray(availabilityCheckResponse.timeslots)) {
            let maxPage = Math.ceil(availabilityCheckResponse.timeslots.length / slotsPerPage);
            if (slotPage < maxPage - 1) {
                setSlotPage(slotPage + 1);
            }
        }
    }

    function onCloseConfirmError() {
        setSelectedDate('');
        setSelectedTime('');
        setAvailabilityCheckResponse(null);
        setSlotPage(0);
        //setShowConfirmError(false);
    }

    function _getPreSlotPageClass() {
        return (slotPage == 0 ? 'deactivated' : '') ;
    }

    function _getNextSlotPageClass() {
        if (availabilityCheckResponse && availabilityCheckResponse.result == 1 && Array.isArray(availabilityCheckResponse.timeslots)) {
            let maxPage = Math.ceil(availabilityCheckResponse.timeslots.length / slotsPerPage);
            if (slotPage >= maxPage - 1) {
                return 'deactivated';
            } else {
                return '';
            }
        }
        return 'deactivated';
    }


    useEffect(() => {
        const onConfirmErrorEvent = () => {
            //console.log('confirm error handler called');
            onCloseConfirmError();
        }

        if (document && document.confrimAvaiHandlerAdded != 1) {
            //console.log('----- add listener');
            document.confrimAvaiHandlerAdded = 1;
            document.addEventListener("confirmAvailabilityError", onConfirmErrorEvent);
        }

        return () => {
            if ( document.confrimAvaiHandlerAdded == 1) {
                document.confrimAvaiHandlerAdded = undefined;
                document.removeEventListener("confirmAvailabilityError", onConfirmErrorEvent);
            }
        
        }

    }, [selectedTime]);


    useEffect(() => {
        if (reservationData.isAjax && reservationData.checkoutError) {
            setTimeout(function() {
                //document.querySelector('.rtp_availability_err_overlay .try_again_btn').focus();
                let el = document.querySelector('.rtp_availability_err_overlay .rtp_avail_error_msg');
                if (el) {
                    el.focus();
                }
            }, 10);
        }
    }, []);

    _selectedTimeChangedUIUpdate(selectedTime);

    let primaryBtnColor = rd.siteColors.primaryButtonBackground || rd.siteColors.primary;
    let primaryBtnFontColor = rd.siteColors.primaryButtonFontColor || rd.siteColors.white;
    let container_border_css = [SG.BD_2, SG.NO_BD_LEFT, SG.NO_BD_RIGHT, SG.NO_BD_TOP, SG.F_BODY].join(" ");
    let btnStyle = {backgroundColor: primaryBtnColor, color: primaryBtnFontColor };

    window.rtp_setIsLoading = setIsLoading;


    return (
        <>
            <div className={'rtp_container realtime ' + container_border_css} >

                <div className='rtp_pd_row'>
                    <div className="guest_select_div">
                        <label htmlFor="CartItemSocialInfo_numGuests" >{rd.strings.guestsSelectLable}</label>
                        <select
                            id="CartItemSocialInfo_numGuests"
                            name="CartItemSocialInfo[numGuests]"
                            className={"guest_select " + SG.BD_PRIMARY + ' ' + SG.RC_BD_RADIUS} 
                            style={{borderColor: primaryBtnColor}}
                            value={numGuest}
                            onChange={numGuestChanged}
                            aria-label={rd.strings.guestsSelectLable}
                        >
                            {reservationData.guestsOptions.map(
                                (num, index) => { 
                                    return (
                                        <option key={'numGuest_' + num} value={num}   >
                                            {num}
                                        </option>
                                    )
                                }
                            )}
                        </select>

                        <svg className='select_icon' width="20" height="20" viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M83.3909 183.725L106.609 160.275L246.363 298.646L382.755 160.411L406.245 183.589L246.636 345.354L83.3909 183.725Z" fill={primaryBtnColor}/>
                        </svg>
                    </div>

                    <div  className="calendar_btn_div">
                        <label htmlFor="rpt_calendar_btn" >{rd.strings.dateSelectLabel}</label>
                        <button type="button" id="rpt_calendar_btn" className="calendar_btn clean_button" onClick={clandarBtnClicked}
                            style={{borderColor: primaryBtnColor}}
                            aria-label={rd.strings.dateSelectLabel}
                        >
                            <span className={SG.F_BODY}>
                                {selectedDate ? getDateDisplay(selectedDate) : rd.strings.selectADate}
                            </span>

                            <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M9.38525 4.27552C9.38525 2.99109 8.28798 1.9109 6.88525 1.9109V0.910904C8.79624 0.910904 10.3853 2.39579 10.3853 4.27552C10.3853 5.28069 9.92671 6.1785 9.20985 6.79103L8.56023 6.03077C9.07111 5.59424 9.38525 4.96736 9.38525 4.27552ZM1.88525 5.9109C1.88525 5.08248 2.55683 4.4109 3.38525 4.4109H7.88525V3.4109H3.38525C2.00454 3.4109 0.885254 4.53019 0.885254 5.9109V21.9109C0.885254 23.2916 2.00454 24.4109 3.38525 24.4109H20.3853C21.766 24.4109 22.8853 23.2916 22.8853 21.9109V5.9109C22.8853 4.53019 21.766 3.4109 20.3853 3.4109H19.4686V4.4109H20.3853C21.2137 4.4109 21.8853 5.08248 21.8853 5.9109V21.9109C21.8853 22.7393 21.2137 23.4109 20.3853 23.4109H3.38525C2.55683 23.4109 1.88525 22.7393 1.88525 21.9109V5.9109ZM11.4186 4.4109H16.0853V3.4109H11.4186V4.4109ZM3.88525 9.4109H19.8853V8.4109H3.88525V9.4109ZM14.8853 1.9109C16.288 1.9109 17.3853 2.99109 17.3853 4.27552C17.3853 4.96736 17.0711 5.59424 16.5602 6.03077L17.2098 6.79103C17.9267 6.1785 18.3853 5.28069 18.3853 4.27552C18.3853 2.39579 16.7962 0.910904 14.8853 0.910904V1.9109ZM4.88525 12.4109V14.4109H6.88525V12.4109H4.88525ZM4.38525 11.4109C4.10911 11.4109 3.88525 11.6348 3.88525 11.9109V14.9109C3.88525 15.187 4.10911 15.4109 4.38525 15.4109H7.38525C7.6614 15.4109 7.88525 15.187 7.88525 14.9109V11.9109C7.88525 11.6348 7.6614 11.4109 7.38525 11.4109H4.38525ZM4.88525 20.4109V18.4109H6.88525V20.4109H4.88525ZM3.88525 17.9109C3.88525 17.6348 4.10911 17.4109 4.38525 17.4109H7.38525C7.6614 17.4109 7.88525 17.6348 7.88525 17.9109V20.9109C7.88525 21.187 7.6614 21.4109 7.38525 21.4109H4.38525C4.10911 21.4109 3.88525 21.187 3.88525 20.9109V17.9109ZM10.8853 12.4109V14.4109H12.8853V12.4109H10.8853ZM10.3853 11.4109C10.1091 11.4109 9.88525 11.6348 9.88525 11.9109V14.9109C9.88525 15.187 10.1091 15.4109 10.3853 15.4109H13.3853C13.6614 15.4109 13.8853 15.187 13.8853 14.9109V11.9109C13.8853 11.6348 13.6614 11.4109 13.3853 11.4109H10.3853ZM10.8853 20.4109V18.4109H12.8853V20.4109H10.8853ZM9.88525 17.9109C9.88525 17.6348 10.1091 17.4109 10.3853 17.4109H13.3853C13.6614 17.4109 13.8853 17.6348 13.8853 17.9109V20.9109C13.8853 21.187 13.6614 21.4109 13.3853 21.4109H10.3853C10.1091 21.4109 9.88525 21.187 9.88525 20.9109V17.9109ZM16.8853 12.4109V14.4109H18.8853V12.4109H16.8853ZM16.3853 11.4109C16.1091 11.4109 15.8853 11.6348 15.8853 11.9109V14.9109C15.8853 15.187 16.1091 15.4109 16.3853 15.4109H19.3853C19.6614 15.4109 19.8853 15.187 19.8853 14.9109V11.9109C19.8853 11.6348 19.6614 11.4109 19.3853 11.4109H16.3853ZM16.8853 20.4109V18.4109H18.8853V20.4109H16.8853ZM15.8853 17.9109C15.8853 17.6348 16.1091 17.4109 16.3853 17.4109H19.3853C19.6614 17.4109 19.8853 17.6348 19.8853 17.9109V20.9109C19.8853 21.187 19.6614 21.4109 19.3853 21.4109H16.3853C16.1091 21.4109 15.8853 21.187 15.8853 20.9109V17.9109Z" fill={primaryBtnColor}/>
                            </svg>

                        </button> 
                    </div>
                </div>

                {
                    showAvailabilityError &&
                    <div className={`rtp_availability_err_overlay rtp_overlay ifonly_overlay ${SG.F_BODY}`}  style={{display:'block'}}>
                        <div className={`ifonly_pop ${SG.RC_BD_RADIUS}`} >
                            <button type="button" className="closebtn" onClick={onCloseAvailabilityError} aria-label={rd.strings.close}>
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.2208 1.38562L9.60463 8.078L16.2208 14.7714L15.1154 15.8885L8.49916 9.19519L1.88393 15.8885L0.779434 14.7714L7.39467 8.078L0.779434 1.38562L1.88393 0.267456L8.49916 6.95984L15.1154 0.267456L16.2208 1.38562Z" fill="#141413"/>
                                </svg>
                            </button>

                            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginBottom:'10px'}} aria-label={rd.strings.attention}>
                                <path fillRule="evenodd" clipRule="evenodd" d="M25 7.8125C15.5076 7.8125 7.8125 15.5076 7.8125 25C7.8125 34.4924 15.5076 42.1875 25 42.1875C34.4924 42.1875 42.1875 34.4924 42.1875 25C42.1875 15.5076 34.4924 7.8125 25 7.8125ZM4.6875 25C4.6875 13.7817 13.7817 4.6875 25 4.6875C36.2183 4.6875 45.3125 13.7817 45.3125 25C45.3125 36.2183 36.2183 45.3125 25 45.3125C13.7817 45.3125 4.6875 36.2183 4.6875 25ZM25 17.1875C25.8629 17.1875 26.5625 17.8871 26.5625 18.75V26.5625C26.5625 27.4254 25.8629 28.125 25 28.125C24.1371 28.125 23.4375 27.4254 23.4375 26.5625V18.75C23.4375 17.8871 24.1371 17.1875 25 17.1875ZM23.4375 32.8125C23.4375 31.9496 24.1371 31.25 25 31.25H25.0156C25.8786 31.25 26.5781 31.9496 26.5781 32.8125V32.8281C26.5781 33.6911 25.8786 34.3906 25.0156 34.3906H25C24.1371 34.3906 23.4375 33.6911 23.4375 32.8281V32.8125Z" fill={primaryBtnColor}/>
                            </svg>

                            {availabilityCheckResponse &&
                                <div className="rtp_avail_error_msg" tabIndex="0" dangerouslySetInnerHTML={{ __html: getAvailabilityErrorMsg(availabilityCheckResponse) }} ></div>
                            }

                            {availabilityCheckResponse && availabilityCheckResponse.request_id &&
                                <div className="ref_row" aria-live="assertive">
                                    <span>Ref ID:</span>
                                    <span className="rtp_ref_id_span" onClick={refIdClicked}>{availabilityCheckResponse.request_id}</span>
                                </div>
                            }

                            <div className="btn_row">
                                <button type="button" className={'return_home_btn ' + SG.BD_PRIMARY } style={btnStyle} onClick={onReturnHome}>
                                    {rd.strings.returnToHome}
                                </button>
                                <button type="button" className={'try_again_btn ' + SG.BD_PRIMARY } style={btnStyle} onClick={onCloseAvailabilityError}>
                                    {rd.strings.tryAgain}
                                </button>
                            </div>
                        </div>
                    </div>
                }

                {
                    availabilityCheckResponse && availabilityCheckResponse.result == 1 && Array.isArray(availabilityCheckResponse.timeslots) && availabilityCheckResponse.timeslots.length == 0 &&
                    <div className="rtp_no_availability">   
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={rd.strings.attention}>
                            <path d="M12 0C18.6171 0 24 5.38286 24 12C24 18.6171 18.6171 24 12 24C5.38286 24 0 18.6171 0 12C0 5.38286 5.38286 0 12 0ZM12 1.14258C6.01371 1.14258 1.14258 6.01371 1.14258 12C1.14258 17.9863 6.01371 22.8574 12 22.8574C17.9863 22.8574 22.8574 17.9863 22.8574 12C22.8574 6.01371 17.9863 1.14258 12 1.14258ZM12.5713 19.4287H11.4287V17.1426H12.5713V19.4287ZM12.5713 14.8574H11.4287V4.57129H12.5713V14.8574Z" fill={primaryBtnColor}/>
                        </svg>

                        <span className="rtp_no_avail_msg"  tabIndex="0">{rd.strings.noAvailability}</span>
                    </div>
                }

                {
                    availabilityCheckResponse && availabilityCheckResponse.result == 1 && Array.isArray(availabilityCheckResponse.timeslots) && availabilityCheckResponse.timeslots.length > 0 &&
                    <>
                        <div className="rtp_title_row slots_title" >
                            <span>{reservationData.strings.timeListLabel}</span>

                            <div className="rtp_slot_page_controls" style={{display:availabilityCheckResponse.timeslots.length > slotsPerPage ? 'flex' : 'none'}}>
                                <svg className={"rtp_pre_slot_page " + _getPreSlotPageClass()}  onClick={onPreSlotPageClick}
                                    width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    tabIndex="0" aria-label={rd.strings.previousPage}
                                >
                                    <rect x="28.5" y="28.4713" width="27" height="27" rx="13.5" transform="rotate(-180 28.5 28.4713)" stroke="#141413"/>
                                    <path d="M17 19.9713L12 14.9713L17 9.97127" stroke="#141413" strokeWidth="1.75"/>
                                </svg>

                                <svg className={"rtp_next_slot_page " + _getNextSlotPageClass()} onClick={onNextSlotPageClick}
                                    width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    tabIndex="0"  aria-label={rd.strings.nextPage}
                                >
                                    <rect x="0.5" y="1.47127" width="27" height="27" rx="13.5" stroke="#141413"/>
                                    <path d="M12 9.97127L17 14.9713L12 19.9713" stroke="#141413" strokeWidth="1.75"/>
                                </svg>
                            </div>
                        </div>

                        <div className="rtp_timeslots_div">
                            {
                               availabilityCheckResponse.timeslots.map(
                                    (slot, index) => {
                                        return(
                                            <button type="button" className={'timeslot_btn clean_button ' + SG.BD_PRIMARY + '  ' + SG.RC_BD_RADIUS + ' ' + SG.F_BODY} 
                                                key={slot.real_datetime_of_slot} data-timeslot={slot.real_datetime_of_slot} 
                                                onClick={timeClicked} style={_getTimeSlotCss(slot, selectedTime, index)}
                                            >
                                                {getTimeDisplay(slot.time_slot_iso, slot.time_display)}
                                            </button>
                                        )
                                    }
                                )
                            }
                        </div>
                    </>
                }

                {
                    (reservationData.hintTextBoxRequired == '1') &&
                    <>
                        <div className="rtp_title_row" style={{paddingBottom: '10px'}} >
                            {reservationData.strings.hintText}
                        </div>
                        <textarea id="rtp_hint_text_box" name="CartItemSocialInfo[info]" className={'rtp_hint_text_box ' + SG.BD_PRIMARY + '  ' + SG.RC_BD_RADIUS + ' ' + SG.F_BODY} 
                            rows="3"
                        >
                        </textarea>
                    </>
                
                }

                {   /*
                    showConfirmError &&
                    <div className={`rtp_confirm_err_overlay rtp_overlay ifonly_overlay ${SG.F_BODY}`}  style={{display:'block'}}>
                        <div className={`ifonly_pop ${SG.RC_BD_RADIUS}`} >

                            <button type="button" className="closebtn" onClick={onCloseConfirmError}>
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.2208 1.38562L9.60463 8.078L16.2208 14.7714L15.1154 15.8885L8.49916 9.19519L1.88393 15.8885L0.779434 14.7714L7.39467 8.078L0.779434 1.38562L1.88393 0.267456L8.49916 6.95984L15.1154 0.267456L16.2208 1.38562Z" fill="#141413"/>
                                </svg>
                            </button>

                            <div className="rtp_confirm_error_title">{rd.strings.confirmErrorTitle}</div>

                            <div >{rd.strings.confirmErrorText}</div>

                            <div className="btn_row">
                                <button type="button" className={'restaurant_btn ' + SG.BD_PRIMARY } style={btnStyle} onClick={onCloseConfirmError}>
                                    {rd.strings.confirmErrorBtnText}
                                </button>
                            </div>
                        </div>
                    </div>
                    */
                }


                <input type="hidden" className="hidden_selected_date" value={selectedDate} />
                <input type="hidden" name="Schedule[date][0]" className="hidden_selected_time" value={selectedTime} />


                {typeof(localStorage) != 'undefined' && localStorage.rtp_debug == '1' &&
                    <div>
                        numGuest: {numGuest}<br />
                        selected date: {selectedDate} <br />
                        selected time: {selectedTime}
                    </div>
                }

                <style>
                    {'.rtp_spinner::after {background:' + primaryBtnColor + ';}'}
                </style>

                {
                    <div className="rtp_timeslots_loading" style={{display: (isLoading? 'flex' : 'none')}}>
                        <div className='rtp_spinner' style={{background:'conic-gradient( from 90deg at 50% 50%,rgba(39, 174, 96, 0) 0deg, rgba(31, 144, 255, 0) 0.04deg, ' + primaryBtnColor + ' 360deg)'}} />
                        <span className="loading_msg screen-reader-only" role="status" aria-live="assertive" aria-atomic="true"></span>
                    </div>
                }

            </div>

            <Datepicker 
                startDate = {reservationData.startDate}
                endDate = {reservationData.endDate}
                activeDates = {{'any':true}}
                monthTexts = {reservationData.monthTexts}
                weekDayTexts = {reservationData.weekDayTexts}
                dateLegnedAvailable = {reservationData.strings.dateLegnedAvailable}
                dateLegnedUnavailable = {reservationData.strings.dateLegnedUnavailable}
                show = {showDatepicker} 
                onClose = {setShowDatepicker}
                onDatePicked = {onDatePicked}
                onOverlayPicked = {onOverlayPicked}
                selectedDate = {selectedDate}
                selectedDateBackgroundColor = {primaryBtnColor}
                selectedDateColor = {primaryBtnFontColor}
            />
        </>
    )
}

export default ReservationTriplePickerRealtime;